import { useTranslation } from 'react-i18next'
import { RateCard } from './RateCard'


const FoundRateCard = ({foundRate, isLoading}) => {
    const [t] = useTranslation()

    const foundPercentRate = Math.round(foundRate * 100)

    return (
      <RateCard
        cardLabel={t('dashboard.found_rate.title')}
        chartLabel={t('dashboard.found_rate.label')}
        rate={foundPercentRate}
        isLoading={isLoading}
      />
    )
}

export { FoundRateCard }
